import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IIntegrationTypeListRequest {
  page: number;
  size: number;
  orderByDesc: boolean;
  orderBy: string;
}

async function getIntegrationTypes(data: IIntegrationTypeListRequest): Promise<any> {
  try {
    return (await axiosInstance.post(`/IntegrationType/List`, data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetIntegrationTypes(request: IIntegrationTypeListRequest) {
  return useQuery(['integrationTypes', request], () => getIntegrationTypes(request));
}